import Configuration from "@/configuration";
import ApiResponse from "./models/ApiResponse";

import * as GetInfo from "./models/Anima/GetInfo";
import * as IsInRoles from "./models/User/IsInRoles";
import * as GetUser from "./models/User/GetUser";
import * as GetCustomer from "./models/Customer/GetCustomer";
import * as CreateCustomer from "./models/Customer/CreateCustomer";
import * as GetCustomerDetail from "./models/Customer/GetCustomerDetail";
import * as UpdateCustomerConsentGroup from "./models/Customer/UpdateCustomerConsentGroup";
import * as UpdateCustomer from "./models/Customer/UpdateCustomer";

// TODO(károly): intero file è temporaneo, rimuovere e passare a quello Swagger appena possibile.
const Persistency = window.localStorage;

const executeGetAsync = async function<TPayload> (path: string): Promise<TPayload> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json"
  };

  const accessToken = Persistency.getItem("accessToken");
  if (accessToken) {
    headers.Authorization = "Bearer " + accessToken;
  }

  const response = await fetch(path, {
    method: "get",
    headers: headers
  });

  // Se è una 401, a prescindere, cancello l'eventuale token di accesso.
  if (response.status === 401) {
    Persistency.removeItem("accessToken");
    Persistency.removeItem("userData");

    if (window && window.location) {
      window.location.reload();
    }
  }

  return response.json();
};
const executeRequestAsync = async function<TRequest, TPayload> (path: string, data: TRequest): Promise<TPayload> {
  const headers: Record<string, string> = {
    "Content-Type": "application/json"
  };

  const accessToken = Persistency.getItem("accessToken");
  if (accessToken) {
    headers.Authorization = "Bearer " + accessToken;
  }

  const response = await fetch(path, {
    method: "POST",
    headers: headers,
    body: JSON.stringify(data)
  });

  // Se è una 401, a prescindere, cancello l'eventuale token di accesso.
  if (response.status === 401) {
    Persistency.removeItem("accessToken");
    Persistency.removeItem("userData");

    if (window && window.location) {
      window.location.reload();
    }
  }

  return response.json();
};

export default {
  async logInAsync (username: string, password: string): Promise<boolean> {
    const data = new URLSearchParams();
    data.append("grant_type", "password");
    data.append("username", username);
    data.append("password", password);
    data.append("client_id", Configuration.oAuthClientId.toString());
    data.append("client_secret", Configuration.oAuthClientSecret);
    data.append("scope", "*");

    const response = await fetch("/oauth/token", {
      method: "post",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      },
      body: data
    });

    const json: {
      access_token: string;
      error: string;
      message: string;
    } = await response.json();

    if (json.error) {
      return false;
    }

    Persistency.setItem("accessToken", json.access_token);

    const getMeResult = await this.user.getMe();
    Persistency.setItem("userData", JSON.stringify(getMeResult));

    return true;
  },

  user: {
    isInRolesAsync (roles: Array<string>): Promise<ApiResponse<IsInRoles.Response>> {
      return executeRequestAsync<IsInRoles.Request, ApiResponse<IsInRoles.Response>>("/api/user/isInRoles", { roles: roles });
    },
    getMe (): Promise<GetUser.Response> {
      return executeGetAsync<GetUser.Response>("/api/me");
    }
  },
  customers: {
    getAsync (page: number, perPage: number, filterName: string): Promise<GetCustomer.Response> {
      return executeGetAsync<GetCustomer.Response>("/api/me/customers?page=" + page + "&perPage=" + perPage + (filterName ? "&filter_name=" + filterName : ""));
    },
    getFilteredDataAsync(page: number, perPage: number, filterName: string, showComplianceCustomers: boolean, showNoComplianceCustomers: boolean, showIncompleteCustomers: boolean, filterproducercode: null|string, dataUploadDa: Date|null, dataUploadA: Date|null, compliantDateFrom: Date|null, compliantDateTo: Date|null, userId: number|null, autoApprovati: boolean, includeSubProducers: boolean): Promise<GetCustomer.Response> {
      return executeGetAsync<GetCustomer.Response>("/api/me/customers?page=" + page + "&perPage=" + perPage + (filterName ? "&filter_name=" + filterName : "") + "&show_compliance_customers=" + showComplianceCustomers + "&show_no_compliance_customers=" + showNoComplianceCustomers + "&show_incomplete_customers=" + showIncompleteCustomers + "&filter_producer_code=" + filterproducercode + "&upload_date_from=" + dataUploadDa + "&upload_date_to=" + dataUploadA + "&compliant_date_from=" + compliantDateFrom + "&compliant_date_to=" + compliantDateTo + "&user_id=" + userId + "&auto_approvato=" + autoApprovati + "&include_sub_producers=" + includeSubProducers);
    },
    getAllProducers(): Promise<GetCustomer.Response> {
      return executeGetAsync<GetCustomer.Response>("/api/me/producers");
    },
    getAllUsers(): Promise<GetCustomer.Response> {
      return executeGetAsync<GetCustomer.Response>("/api/me/users");
    }
  },

  customer: {
    getAsync (id: number): Promise<GetCustomer.Response> {
      return executeGetAsync<GetCustomer.Response>("/api/customer/" + id);
    },

    getDetailAsync (id: number): Promise<GetCustomerDetail.Response> {
      return executeGetAsync<GetCustomerDetail.Response>("/api/customer/" + id + "/detail");
    },

    newAsync (customer: CreateCustomer.Request): Promise<CreateCustomer.Response> {
      return executeRequestAsync<CreateCustomer.Request, CreateCustomer.Response>("/api/new/customer", customer);
    },

    updateCustomerConsentsAsync (url: string, request: UpdateCustomerConsentGroup.Request) {
      return executeRequestAsync<UpdateCustomerConsentGroup.Request, any>(url, request);
    },

    updateCustomerAsync (id: number | undefined, customer: UpdateCustomer.Request) {
      return executeRequestAsync<UpdateCustomer.Request, UpdateCustomer.Response>("/api/customer/" + id + "/update", customer);
    }
  },

  anima: {
    getInfoAsync (request: GetInfo.Request): Promise<GetInfo.Response> {
      return executeRequestAsync<GetInfo.Request, GetInfo.Response>("/anima/api/getinfo", request);
    }
  }
};
